module.exports = __webpack_public_path__ + "img/39600.aa03d34b.jpg";